import { createContext, useMemo, useContext } from "react";
import { useFunction } from "../../Firebase/functions";
import { GlobalContext } from "./GlobalProvider";

export const FunctionsContext = createContext({});

export const FunctionsProvider = ({ children }) => {
  const { firebaseState } = useContext(GlobalContext);

  const getAllVideos = useFunction(firebaseState.getAllVideos, {
    noArguments: true,
  });
  const getAverages = useFunction(firebaseState.getAverages);

  const getTierGroupsByCompany = useFunction(
    firebaseState.getTierGroupsByCompany,
  );
  const getTierGroupsByCompParent = useFunction(
    firebaseState.getTierGroupsByCompParent,
  );
  const updateGroup = useFunction(firebaseState.updateGroup);
  const getAllCompaniesData = useFunction(firebaseState.getAllCompaniesData);
  const getTiersByCompany = useFunction(firebaseState.getTiersByCompany);
  const getTiersByCompetition = useFunction(
    firebaseState.getTiersByCompetition,
  );
  const getCompanyById = useFunction(firebaseState.getCompanyById);
  const getAllCompetitions = useFunction(firebaseState.getAllCompetitions);
  const getCompetitionByCompany = useFunction(
    firebaseState.getCompetitionByCompany,
  );

  const getCampaignDraftById = useFunction(firebaseState.getCampaignDraftById);
  const getAdminCampaigns = useFunction(firebaseState.getAdminCampaigns);
  const getCampaignDraftsByTeams = useFunction(
    firebaseState.getCampaignDraftsByTeams,
  );
  const listAllUserTeams = useFunction(firebaseState.listAllUserTeams);
  const getAllUsers = useFunction(firebaseState.getAllUsers, {
    noArguments: true,
  });

  const getCompParentById = useFunction(firebaseState.getCompParentById);
  const getCompParentsByCompany = useFunction(
    firebaseState.getCompParentsByCompany,
  );
  const getCompParentsByIdArray = useFunction(
    firebaseState.getCompParentsByIdArray,
  );
  const updateCompParent = useFunction(firebaseState.updateCompParent);

  const getAllPrizeTypes = useFunction(firebaseState.getAllPrizeTypes, {
    noArguments: true,
  });

  const getCompetitionCampaigns = useFunction(
    firebaseState.getCompetitionCampaigns,
  );

  const getConstant = useFunction(firebaseState.getConstant);

  const store = useMemo(
    () => ({
      getAllVideos,
      getAverages,
      getTierGroupsByCompany,
      getTierGroupsByCompParent,
      updateGroup,
      getAllCompaniesData,
      getTiersByCompany,
      getCompanyById,
      getCompetitionByCompany,
      getCampaignDraftById,
      getAdminCampaigns,
      getCampaignDraftsByTeams,
      listAllUserTeams,
      getAllUsers,
      getCompParentById,
      getCompParentsByCompany,
      getCompParentsByIdArray,
      updateCompParent,
      getTiersByCompetition,
      getAllCompetitions,
      getAllPrizeTypes,
      getCompetitionCampaigns,
      getConstant,
    }),
    [
      getAllCompaniesData,
      getAllVideos,
      getAverages,
      getTierGroupsByCompany,
      getTierGroupsByCompParent,
      updateGroup,
      getTiersByCompany,
      getCompanyById,
      getCompetitionByCompany,
      getCampaignDraftById,
      getAdminCampaigns,
      getCampaignDraftsByTeams,
      listAllUserTeams,
      getAllUsers,
      getCompParentById,
      getCompParentsByCompany,
      getCompParentsByIdArray,
      updateCompParent,
      getTiersByCompetition,
      getAllCompetitions,
      getAllPrizeTypes,
      getCompetitionCampaigns,
      getConstant,
    ],
  );

  return (
    <FunctionsContext.Provider value={store}>
      {children}
    </FunctionsContext.Provider>
  );
};
